"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IcertisMarkIcon = function IcertisMarkIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: size,
    height: size,
    viewBox: "46 51 274 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-sentry-element": "svg",
    "data-sentry-component": "IcertisMarkIcon",
    "data-sentry-source-file": "IcertisMarkIcon.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M99.4382 91.3132V348.708H320V91.3132H99.4382ZM303.346 332.032H116.02V107.917H303.346V332.032Z",
      fill: "#00E4BC",
      "data-sentry-element": "path",
      "data-sentry-source-file": "IcertisMarkIcon.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M261.71 51L46 96.8961L99.4388 348.635L315.149 302.739L261.71 51ZM65.6956 109.73L248.966 70.7215L295.526 289.978L112.255 328.986L65.6956 109.73Z",
      fill: "url(#icertis-mark-gradient)",
      "data-sentry-element": "path",
      "data-sentry-source-file": "IcertisMarkIcon.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      "data-sentry-element": "defs",
      "data-sentry-source-file": "IcertisMarkIcon.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "icertis-mark-gradient",
        x1: "98.9133",
        y1: "348.985",
        x2: "259.046",
        y2: "55.1774",
        gradientUnits: "userSpaceOnUse",
        "data-sentry-element": "linearGradient",
        "data-sentry-source-file": "IcertisMarkIcon.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#010172",
          "data-sentry-element": "stop",
          "data-sentry-source-file": "IcertisMarkIcon.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.577133",
          stopColor: "#2B38C2",
          "data-sentry-element": "stop",
          "data-sentry-source-file": "IcertisMarkIcon.tsx"
        })]
      })
    })]
  });
};
var _default = exports.default = IcertisMarkIcon;